<template>
  <div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了">
      <div class="aui-content aui-margin-b-15">
        <ul class="aui-list aui-media-list" v-for="(item,i) in comments" :key="i">
          <li class="aui-list-item">
            <div class="aui-media-list-item-inner">
              <div class="aui-list-item-media maui-directories-media">
                <img :src="item.imgurl" />
              </div>
              <div class="aui-list-item-inner">
                <div class="aui-list-item-text">
                  <div class="aui-list-item-title">
                    <span class="maui-name">{{item.master}}</span>
                    <span class="maui-title">{{item.directors}}</span>
                  </div>
                </div>
                <div class="aui-list-item-text maui-company">{{item.companyName}}</div>
                <div class="aui-list-item-text">
                  <div class="maui-tel">
                    <i class="aui-iconfont aui-icon-mobile"></i>
                    {{item.phone}}
                  </div>
                </div>
                <div class="aui-list-item-text">
                  <div class>
                    <i class="aui-iconfont aui-icon-location"></i>
                    {{item.areaName}}
                  </div>
                </div>
                <div class="aui-list-item-text">
                  <div class="maui-tel">业务范围： {{item.business}}</div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  name: "searchaddresslistList",
  data() {
    return {
      kyeWord: "",
      arr: [],
      showPage: 1,
      pageSize: 4,
      comments: [],
      pageindex: 1,
      loading: false,
      totalElements: "",
      finished: false
    };
  },
  props: {
    childrouter: {
      type: String,
      default: ""
    }
  },
  created() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.$axios
        .get(
          "/micro/permission_zuul/user/read/queryWxUser?pageNo=" +
            this.pageindex +
            "&pageSize=&sort=0&goodsClassId=&kyeWord=" +
            this.childrouter
        )
        .then(res => {
          // this.comments = result.body.message;
          // 不替换老数据
          console.log(res);
          this.comments = this.comments.concat(res.data.data.wxUserList);
          this.totalElements = res.data.data.totalElements;
        }); // 异步更新数据
      setTimeout(() => {
        // 异步滑动加载数据
        this.getMore(); // 加载状态结束
        this.loading = false;
        if (this.comments.length >= this.totalElements) {
          this.finished = true;
        }
      }, 2000);
    },
    getMore() {
      this.pageindex++;
    }
  }
};
</script>

<style scoped>
.maui-bar.aui-bar-nav {
  background-color: #fff;
  color: #000;
  border-bottom: solid 0.1rem #efefef;
}
.aui-label-outlined.aui-label-danger,
.aui-label-outlined.aui-label-danger::after {
  border: solid 0.1rem #c9eee1;
  color: #3bb18a;
}
.aui-bar-nav .aui-btn .aui-iconfont {
  color: #000;
  font-weight: bold;
}
.aui-list {
  background: none;
}
.aui-list .aui-list-item-title {
  font-size: 0.75rem;
}
.aui-list-item-text.maui-company {
  line-height: 1.2rem;
  font-size: 0.6rem;
  color: #4f4f4f;
  justify-content: flex-start;
}
.aui-list .aui-list-item-media {
  width: 6.5rem;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.maui-tel {
  font-size: 0.6rem;
  color: #4f4f4f;
}
.maui-tel i {
  color: #3ec26d;
  margin-right: 0.2rem;
}

.aui-list .aui-list-item-media.maui-directories-media {
  width: 3.75rem;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.aui-list .aui-list-item-media.maui-directories-media img {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
}

.maui-search.aui-searchbar {
  background-color: #fff;
}
.maui-search .aui-searchbar-input {
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  border-radius: 0.75rem;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.maui-search .aui-searchbar-cancel {
}
.maui-search button {
  background: none;
  border: none;
  cursor: pointer;
}
.maui-name {
  font-size: 0.8rem;
  margin-right: 0.5rem;
}
.maui-title {
  font-size: 0.6rem;
}

@media only screen and (max-width: 768px) {
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 480px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 49%;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 100%;
  }
}
@media only screen and (max-width: 320px) {
  .aui-list .aui-list-item-label,
  .aui-list .aui-list-item-label-icon {
    width: 40%;
    font-size: 0.6rem;
  }
  .aui-list .maui-textmore-item .aui-list-item-label {
    width: 70%;
    font-size: 0.6rem;
  }
  .aui-input,
  input[type="text"],
  input[type="password"],
  input[type="search"],
  input[type="email"],
  input[type="tel"],
  input[type="url"],
  input[type="date"],
  input[type="datetime-local"],
  input[type="time"],
  input[type="number"],
  select,
  textarea {
    font-size: 0.6rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/searchaddresslistList.vue